<template>
  <hm-content title>
    <div class="table-panel flex flex-between">
      <el-button type="primary" size="small" @click="syncLiveRoom"
        >同步直播间</el-button
      >
      <div class="flex item-center">
        <div class="pointer" @click="openDialogHomeLive">
          <span class="delete-icon hmicon icon-xitong"></span>
          首页直播悬浮设置
        </div>
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
        :index="index => index + (currentPage - 1) * pageSize + 1"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="roomName"
          label="直播标题"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="anchorName"
          label="主播昵称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="roomId"
          label="直播间ID"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shareImg"
          label="直播间封面"
        >
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              class="mr10"
              :src="scope.row.shareImg"
              :preview-src-list="[scope.row.shareImg]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="liveStatus"
          label="直播状态"
        >
          <template slot-scope="scope">
            <span class="status playing" v-if="scope.row.liveStatus === 101"
              >直播中</span
            >
            <span class="status not-start" v-if="scope.row.liveStatus === 102"
              >即将开始</span
            >
            <span class="status end" v-if="scope.row.liveStatus === 103"
              >已结束</span
            >
            <span class="status end" v-if="scope.row.liveStatus === 104"
              >禁播</span
            >
            <span class="status end" v-if="scope.row.liveStatus === 105"
              >暂停中</span
            >
            <span class="status end" v-if="scope.row.liveStatus === 106"
              >异常</span
            >
            <span class="status end" v-if="scope.row.liveStatus === 107"
              >已过期</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="startTime"
          label="开播时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="endTime"
          label="结束直播"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="liveStatus"
            label="房间状态"
        >
          <template slot-scope="scope">
            <span class="status playing" v-if="scope.row.showStatus === 'yes'"
            >显示</span
            >
            <span class="status not-start" v-if="scope.row.showStatus === 'no'"
            >隐藏</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="360"
        >
          <template slot-scope="scope">
            <div class="flex item-center flex-start flex-wrap">
<!--              <el-switch-->
<!--                v-model="scope.row.showStatus"-->
<!--                class="mr20"-->
<!--                size="mini"-->
<!--                active-color="#13ce66"-->
<!--                @change="switchShowStatus(scope.row)"-->
<!--                inactive-color="#ff4949"-->
<!--                active-value="yes"-->
<!--                inactive-value="no"-->
<!--              ></el-switch>-->
              <el-button
                v-if="scope.row.liveStatus === 103"
                type="text"
                size="small"
                @click="replay(scope.row)"
                >直播回放</el-button
              >
              <el-button type="text" size="small" @click="createUrl(scope.row)"
                >生成打榜列表</el-button
              >
              <el-button type="text" size="small" @click="deleteRoom(scope.row)"
              >删除直播</el-button
              >
              <el-button type="text" size="small" v-if="scope.row.showStatus === 'yes'" @click="setRoomShowStatus(scope.row, 'no')"
              >隐藏房间</el-button
              >
              <el-button type="text" size="small" v-if="scope.row.showStatus === 'no'" @click="setRoomShowStatus(scope.row, 'yes')"
              >显示房间</el-button
              >
              <el-button type="text" size="small" @click="handleShowList(scope.row)"
              >查看榜单</el-button
              >
            </div>

          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination mb20">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>

    <el-dialog
      title="打榜商品地址"
      :visible.sync="createRankDialogVisible"
      :close-on-click-modal="false"
    >
      <div>
        <p class="paragraph">
          请复制链接粘贴到小程序创建商品地址输入框:
        </p>
        <div>
          <div class="link">{{ rankUrl }}</div>
          <input
            class="copy-ipt"
            type="text"
            :value="rankUrl"
            ref="activityListUrl"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="copyUrl" type="primary" size="small"
          >复制链接</el-button
        >
        <el-button size="small" @click="createRankDialogVisible = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="回放列表"
      :close-on-click-modal="false"
      @close="dialogVisible = false"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <div class="video-list flex flex-wrap">
        <div v-for="(v, i) in videoList" :key="i">
          <video :src="v.media_url" controls="controls">
            您的浏览器不支持播放回放，请更换最新浏览器
          </video>
          <div class="video-info">过期时间：{{ v.expire_time }}</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="首页直播悬浮设置"
      :visible.sync="dialogHomeLive"
      :close-on-click-modal="false"
    >
      <el-form
        :model="ruleFormHomeLive"
        :rules="ruleFormHomeLiverules"
        ref="ruleFormHomeLive"
        label-width="150px"
        class="demo-ruleForm"
      >
        <div>
          <el-form-item label="悬浮图水印:" prop="logoMask">
            <el-upload
              class="upload flex"
              ref="eluploadMainPic"
              :limit="1"
              drag
              :data="{ fileDir: 'mall' }"
              :headers="{ 'X-Access-Token': $token }"
              :action="$uploadUrl"
              :onSuccess="uploadMainPicSucc"
              :beforeUpload="beforeUpload"
              :onProgress="uploading"
              :show-file-list="uploadShow"
              v-if="!ruleFormHomeLive.logoMask"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将图片拖到此处，或
                <em>点击上传</em>
              </div>
            </el-upload>
            <div class="priview" v-if="ruleFormHomeLive.logoMask">
              <el-image
                class="image"
                :src="ruleFormHomeLive.logoMask"
                alt="主图"
                :preview-src-list="[ruleFormHomeLive.logoMask]"
                />
              <div class="opreat-wrapper flex item-center flex-center" v-if="ruleFormHomeLive.logoMask">
                <el-button type="text" @click="handleRemove">删除</el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item class="mb10" label="水印位置:" prop="position">
            <el-radio-group v-model="ruleFormHomeLive.position">
              <el-radio label="top-left">顶部居左</el-radio>
              <el-radio label="top-center">顶部居中</el-radio>
              <el-radio label="top-right">顶部居右</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item class="mb10" label="水印图标:" prop="showLogoMask">
            <el-switch
              v-model="ruleFormHomeLive.showLogoMask"
              active-text="显示"
              inactive-text="隐藏"
              active-color="#13ce66"
              active-value="open"
              inactive-value="close"
            ></el-switch>
          </el-form-item>
          <el-form-item class="mb10" label="关闭按钮:" prop="showClose">
            <el-switch
              v-model="ruleFormHomeLive.showClose"
              active-text="显示"
              inactive-text="隐藏"
              active-color="#13ce66"
              active-value="open"
              inactive-value="close"
            ></el-switch>
          </el-form-item>
          <el-form-item class="mb10" label="显示状态:" prop="state">
            <el-switch
              v-model="ruleFormHomeLive.state"
              active-text="开启"
              inactive-text="关闭"
              active-color="#13ce66"
              active-value="open"
              inactive-value="close"
            ></el-switch>
            <div class="danger">Tips:显示状态开启时,至少有一场正在直播的直播间才会显示,如有多场正在直播的直播间,则显示排序的第一场</div>
          </el-form-item>
        </div>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitRuleFormHomeLive('ruleFormHomeLive')"
            >保存</el-button
          >
          <el-button size="small" @click="dialogHomeLive = false"
            >取消</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <!-- 直播榜单查看 -->
    <el-dialog
      title="直播榜单"
      :close-on-click-modal="false"
      @close="showListDialog = false"
      :visible.sync="showListDialog"
      destroy-on-close
      width="60%"
    >
      <el-table stripe border :data="dialogTable">
        <!-- <el-table-column align="center" width="60px" label="序号" type="index"></el-table-column> -->
        <el-table-column align="center" label="直播间ID" prop="live_id"></el-table-column>
        <el-table-column align="center" label="直播间名称" prop="room_name"></el-table-column>
        <el-table-column align="center" label="推荐人手机号" prop="member_mobile"></el-table-column>
        <el-table-column align="center" label="推荐人姓名" prop="member_name"></el-table-column>
        <el-table-column align="center" label="邀请数量" prop="count"></el-table-column>
      </el-table>
      <div class="page-wrap">
        <el-pagination
          @size-change="handleDialogSizeChange"
          @current-change="handleDialogCurrentChange"
          :current-page="dialogPageNo"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="dialogPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="dialogTotal">
        </el-pagination>
      </div>
    </el-dialog>

      <el-dialog
        title='快捷下单'
        :visible.sync='quickOrderVisible'
        width='600px'
        :close-on-click-modal='false'
        :close-on-press-escape='false'
        destroy-on-close
        custom-class='common-dialog'
      >
        <div class='remarks-info'>快捷下单</div>
        <img src="" alt="二维码" />
        <template slot='footer'>
          <el-button @click='quickOrderVisible = false' type='primary' size='small'>确定</el-button>
        </template>
      </el-dialog>
  </hm-content>
</template>

<script>
import moment from "moment";
import { getLoginUser } from "@/utils/auth";
export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      videoList: [],
      currentPage: 1,
      pageSize: 10,
      rankUrl: "",
      currentRow: "",
      list: [],
      total: 0,
      createRankDialogVisible: false,
      storeCode: "",
      uploadShow: true,
      dialogHomeLive: false,
      ruleFormHomeLive: {
        logoMask: "",
        position: "top-right",
        showLogoMask: "open",
        showClose: "open",
        state: "close",
      },
      ruleFormHomeLiverules:{},
      showListDialog: false,
      dialogPageNo: 1,
      dialogPageSize: 10,
      dialogTotal: 0,
      dialogTable: [],
      quickOrderVisible: false
    };
  },
  computed: {},
  watch: {},
  created() {
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    this.queryList();
  },
  mounted() {},
  methods: {
    handleDialogSizeChange(val) {
      this.dialogPageSize = val
      this.dialogPageNo = 1
      this.getDialotTable()
    },
    handleDialogCurrentChange(val) {
      this.dialogPageNo = val
      this.getDialotTable()
    },
    createUrl(row) {
      this.createRankDialogVisible = true;
      this.currentRow = row;
      this.rankUrl = `live/liveInviteRank?roomId=${row.roomId}`;
    },
    copyUrl() {
      const input = this.$refs.activityListUrl;
      input.select(); // 选中文本
      document.execCommand("copy");
      this.$message({
        type: "success",
        message: "操作成功"
      });
    },
    async switchShowStatus(row) {
      await this.$store.dispatch("editLiveShowOrHide", {
        liveId: row.liveId,
        showStatus: row.showStatus
      });
      this.$message({
        type: "success",
        message: "同步成功"
      });
      this.queryList();
    },
    async syncLiveRoom() {
      await this.$store.dispatch("syncLiveRoom");
      this.$message({
        type: "success",
        message: "同步成功"
      });
      this.queryList();
    },
    async replay(row) {
      const { result } = await this.$store.dispatch("getReplayList", {
        room_id: row.roomId
      });
      const { live_replay } = result;
      let replayList = live_replay.filter(v => !/m3u8/.test(v.media_url));
      replayList.forEach(v => {
        v.expire_time = moment(v.expire_time).format("YYYY-MM-DD HH:mm:ss");
      });
      if (replayList.length) {
        this.videoList = [];
        this.videoList = replayList;
        this.dialogVisible = true;
      } else {
        this.$message({
          type: "warning",
          message: "暂无回放"
        });
      }
    },
    async queryList() {
      const { result } = await this.$store.dispatch("queryLiveList", {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      });
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    async deleteRoom(row) {
      await this.$store.dispatch("deleteLiveRoom", {
        roomId: row.roomId
      });
      this.$message({
        type: "success",
        message: "删除成功"
      });
      this.queryList();
    },
    async setRoomShowStatus(row, status) {
      await this.$store.dispatch("setRoomShowStatus", {
        roomId: row.roomId,
        showStatus: status
      });
      this.$message({
        type: "success",
        message: "设置成功"
      });
      this.queryList();
    },
    /**
     * @desc 查看榜单
    */
    async handleShowList(row) {
      this.rowItem = row
      this.getDialotTable()
    },
    async getDialotTable() {
      // const { result } = await this.$store.dispatch('recommendRankingPage', {liveId: 150, storeCode: 42010616031788,pageSize: this.dialogPageSize,
      //   pageNo: this.dialogPageNo })
      const { result } = await this.$store.dispatch('recommendRankingPage', {liveId: this.rowItem.roomId, storeCode: this.storeCode, pageSize: this.dialogPageSize,
        pageNo: this.dialogPageNo })
      this.dialogTotal = result.total
      this.dialogTable = result.records
      this.showListDialog = true
    },
    async queryStoreConfigLive(){      
      const { result } = await this.$store.dispatch("queryStoreConfigLive", {
        storeCode: this.storeCode,
        code:"liveSuspension",
      });
      console.log("result:",result);
      if(result.value){
        this.ruleFormHomeLive = JSON.parse(result.value);
      }else{
        this.addStoreConfigLive();
      }
    },
    async addStoreConfigLive(){
      let value = JSON.stringify(this.ruleFormHomeLive);
      const { result } = await this.$store.dispatch("addStoreConfigLive", {
        storeCode: this.storeCode,
        code:"liveSuspension",
        name:"新增首页直播中悬浮",
        value: value,
      });
      console.log("result:",result);
    },
    async editStoreConfigLive(){
      let value = JSON.stringify(this.ruleFormHomeLive);
      const { result } = await this.$store.dispatch("editStoreConfigLive", {
        storeCode: this.storeCode,
        code:"liveSuspension",
        name:"编辑首页直播中悬浮",
        value: value,
      });
      this.$message({
        type: "success",
        message: "设置成功"
      });
      this.queryStoreConfigLive();
      this.dialogHomeLive = false;
    },
    // 正在上传
    uploading() {
      this.uploadShow = true;
    },
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpg" ||
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "gif";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      const limitSize = file.size / 1024 <= 1020;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      if (!limitSize) {
        this.$message({
          message: "上传模板大小不能超过 1M!",
          type: "warning"
        });
      }
      return (extension || extension2 || extension3 || extension4) && limitSize;
    },
    uploadMainPicSucc(jsonData) {
      if (jsonData.code === 0) {
        this.ruleFormHomeLive.logoMask = jsonData.result;
        this.uploadShow = false;
      }
    },
    // 移除上传文件
    handleRemove() {
      this.ruleFormHomeLive.logoMask = "";
    },
    openDialogHomeLive(){
      this.queryStoreConfigLive();
      this.dialogHomeLive = true;
    },
    // 提交
    submitRuleFormHomeLive(formName){
      this.editStoreConfigLive();      
    },
  }
};
</script>
<style lang="scss" scoped>
.status {
  &.playing {
    color: #f72c2c;
  }
  &.not-start {
    color: #0282e6;
  }
  &.end {
    color: #999;
  }
}

.video-list {
  video {
    width: 200px;
    margin-right: 20px;
  }
}

.copy-ipt {
  position: fixed;
  left: -100vw;
}

.link {
  margin-top: 30px;
}
.priview {
  position: relative;
  width: 360px;
  height: 180px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  .image {
    width: 100%;
    height: 100%;
  }
  .video {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.page-wrap {
  text-align: right;
  margin-top: 10px;
  padding: 20px 0;
}
.flex-wrap {
  flex-wrap: wrap;
}
</style>
